export enum ProductStatus {
	PENDING = 'pending',
	PROCESSING = 'processing',
	PAID = 'paid',
	PAYMENT_ERROR = 'payment_error',
	CONFIRMED = 'confirmed',
	DELIVERED = 'delivered',
	REFUNDED_CANCELED = 'refunded_canceled',
	REDUNDED_DELIVERED = 'refunded_delivered',
}
